module.exports = __webpack_public_path__ + "static/media/ai-power-search-banner.b77002b5.png";